/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";

// Components
import Header from "./header";
import Footer from "./footer";

// SCSS
import { main } from "../style/style.module.scss";

const Layout = ({ children }: { children: any }): JSX.Element => (
  <>
    <Header />
    <main className={main}>{children}</main>
    <Footer />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
